import { ReimbursementOperation } from "../@core/constants";

export class Reimbursement {
    code: string;
    operationDescription: string;
    documentNumber: string;
    operationNumber: string;
    operation: ReimbursementOperation;
    branchCode: string;
    date: string;
    dateRaw: Date;
    salesOrgCode: string;
    salesOrgOriginalCode: string;
    registerBoxNumber: string;
    registerBoxDescription: string;
    customerCode: string;
    customerName: string;
    currency: string;
    total: number;
    user: string;
    assignment: string;
    reference: string;
    voidReimbursementCode: string;
    isVoided: boolean;
    generalText: string;
    registerCode: string;

    /**
     *
     */
    constructor() {
        this.code = "";
        this.operationDescription = "";
        this.documentNumber = "";
        this.operationNumber = "";
        this.operation = ReimbursementOperation.PAYMENT;
        this.branchCode = "";
        this.date = "";
        this.dateRaw = new Date();
        this.salesOrgCode = "";
        this.salesOrgOriginalCode = "";
        this.registerBoxNumber = "";
        this.registerBoxDescription = "";
        this.customerCode = "";
        this.customerName = "";
        this.currency = "";
        this.total = 0.0;
        this.user = "";
        this.assignment = "";
        this.reference = "";
        this.voidReimbursementCode = "";
        this.isVoided = false;
        this.generalText = "";
        this.registerCode = "";

    }
}